enum MetOverallStatus {
  All = "All",
  Yes = "Yes",
  No = "No",
  None = "None"
}

export default MetOverallStatus;